import { render, staticRenderFns } from "./TheInstagramIcon.vue?vue&type=template&id=073845e6&"
import script from "./TheInstagramIcon.vue?vue&type=script&lang=js&"
export * from "./TheInstagramIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports